import {validDateKey} from './activity-model.js';
import {validClock} from './clock-time.js';

const formatter=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Copenhagen',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'});
export function copenhagenFields(value){
 const at=Date.parse(value);if(!Number.isFinite(at))return null;
 const parts=Object.fromEntries(formatter.formatToParts(at).map(p=>[p.type,p.value]));
 return {day:`${parts.year}-${parts.month}-${parts.day}`,clock:`${parts.hour}:${parts.minute}`};
}
// Return both occurrences during the autumn clock change; never invent a spring-gap time.
export function copenhagenInstants(day,clock){
 if(!validDateKey(day)||!validClock(clock))return [];
 return ['+02:00','+01:00'].map(offset=>`${day}T${clock}:00${offset}`).filter(value=>{
  const fields=copenhagenFields(value);return fields?.day===day&&fields.clock===clock;
 });
}
